import { createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment, toDisplayString as _toDisplayString, vModelText as _vModelText, withDirectives as _withDirectives, normalizeClass as _normalizeClass, vShow as _vShow, resolveComponent as _resolveComponent, createVNode as _createVNode } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "fixed right-1 lg:right-4 left-1 lg:left-auto bottom-1 lg:bottom-4 bg-white px-4 py-4 z-50 border-2 border-b-4 border-gray-800 rounded-lg transition-all"
}
const _hoisted_2 = {
  id: "cart-items",
  class: ""
}
const _hoisted_3 = { class: "flex justify-between items-center" }
const _hoisted_4 = {
  key: 0,
  class: "min-w-64 py-5 px-4 text-center bg-gray-100 rounded-md"
}
const _hoisted_5 = { class: "flex flex-col lg:flex-row px-2 py-2 border-b border-gray-200 lg:items-center" }
const _hoisted_6 = ["src"]
const _hoisted_7 = { class: "mt-2 lg:mt-0 lg:px-4" }
const _hoisted_8 = { class: "text-lg font-bold" }
const _hoisted_9 = { class: "text-sm" }
const _hoisted_10 = ["onClick"]
const _hoisted_11 = { class: "flex lg:justify-end items-center gap-2 mt-4 lg:ml-auto" }
const _hoisted_12 = ["value"]
const _hoisted_13 = ["value"]
const _hoisted_14 = { class: "bg-gray-200 flex items-center p-0.5 rounded-md" }
const _hoisted_15 = ["onUpdate:modelValue"]
const _hoisted_16 = ["disabled"]
const _hoisted_17 = { class: "flex gap-2" }
const _hoisted_18 = { class: "px-2 py-2 relative border border-gray-200 mt-2 rounded-lg" }
const _hoisted_19 = ["src"]
const _hoisted_20 = { class: "bg-green-600 text-white rounded-full text-sm absolute bottom-1 right-1 px-1.5 border border-gray-800" }

export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_checkout_form = _resolveComponent("checkout-form")

  return (_openBlock(), _createElementBlock("div", null, [
    _createElementVNode("button", {
      onClick: _cache[0] || (_cache[0] = $event => (_ctx.showCart = true)),
      class: "btn fixed z-50 p-4 bottom-2 lg:bottom-4 right-1 lg:right-4 lg:left-auto bg-green-600 hover:bg-green-700 border-2 border-black text-white rounded-full"
    }, [
      _createCommentVNode(" shopping cat icon"),
      _cache[4] || (_cache[4] = _createElementVNode("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 24 24",
        fill: "currentColor",
        class: "size-10"
      }, [
        _createElementVNode("path", { d: "M2.25 2.25a.75.75 0 0 0 0 1.5h1.386c.17 0 .318.114.362.278l2.558 9.592a3.752 3.752 0 0 0-2.806 3.63c0 .414.336.75.75.75h15.75a.75.75 0 0 0 0-1.5H5.378A2.25 2.25 0 0 1 7.5 15h11.218a.75.75 0 0 0 .674-.421 60.358 60.358 0 0 0 2.96-7.228.75.75 0 0 0-.525-.965A60.864 60.864 0 0 0 5.68 4.509l-.232-.867A1.875 1.875 0 0 0 3.636 2.25H2.25ZM3.75 20.25a1.5 1.5 0 1 1 3 0 1.5 1.5 0 0 1-3 0ZM16.5 20.25a1.5 1.5 0 1 1 3 0 1.5 1.5 0 0 1-3 0Z" })
      ], -1 /* CACHED */))
    ]),
    (_ctx.showCart)
      ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
          _withDirectives(_createElementVNode("div", _hoisted_2, [
            _createElementVNode("div", _hoisted_3, [
              _cache[7] || (_cache[7] = _createElementVNode("div", { class: "font-bold text-xl" }, " Your cart ", -1 /* CACHED */)),
              _createElementVNode("button", {
                onClick: _cache[1] || (_cache[1] = $event => (_ctx.showCart = false)),
                class: "btn flex py-2 hover:border-gray-500 border-transparent border px-2 hover:bg-gray-100"
              }, [
                _cache[5] || (_cache[5] = _createTextVNode(" Close ")),
                _createCommentVNode(" close icon "),
                _cache[6] || (_cache[6] = _createElementVNode("svg", {
                  xmlns: "http://www.w3.org/2000/svg",
                  viewBox: "0 0 24 24",
                  fill: "currentColor",
                  class: "size-6"
                }, [
                  _createElementVNode("path", {
                    "fill-rule": "evenodd",
                    d: "M5.47 5.47a.75.75 0 0 1 1.06 0L12 10.94l5.47-5.47a.75.75 0 1 1 1.06 1.06L13.06 12l5.47 5.47a.75.75 0 1 1-1.06 1.06L12 13.06l-5.47 5.47a.75.75 0 0 1-1.06-1.06L10.94 12 5.47 6.53a.75.75 0 0 1 0-1.06Z",
                    "clip-rule": "evenodd"
                  })
                ], -1 /* CACHED */))
              ])
            ]),
            (_ctx.cart.items.length == 0)
              ? (_openBlock(), _createElementBlock("div", _hoisted_4, " Your cart is empty "))
              : _createCommentVNode("v-if", true),
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.cart.items, (item) => {
              return (_openBlock(), _createElementBlock("div", _hoisted_5, [
                _createElementVNode("img", {
                  src: _ctx.productImage(item),
                  class: "size-16 border border-gray-200 rounded-md"
                }, null, 8 /* PROPS */, _hoisted_6),
                _createElementVNode("div", _hoisted_7, [
                  _createElementVNode("p", _hoisted_8, _toDisplayString(item.product.name), 1 /* TEXT */),
                  _createElementVNode("p", _hoisted_9, _toDisplayString(item.product.description), 1 /* TEXT */),
                  _createElementVNode("button", {
                    onClick: $event => (_ctx.removeItem(item)),
                    class: "btn px-0 py-1 hover:text-red-500 flex items-center gap-1"
                  }, " Remove ", 8 /* PROPS */, _hoisted_10)
                ]),
                _createCommentVNode(" quantity and color "),
                _createElementVNode("div", _hoisted_11, [
                  _createElementVNode("select", {
                    class: "hidden bg-gray-200 rounded-md p-1 px-2",
                    value: item.color
                  }, [
                    (_openBlock(), _createElementBlock(_Fragment, null, _renderList(['gray', 'beige'], (color) => {
                      return _createElementVNode("option", { value: color }, _toDisplayString(color), 9 /* TEXT, PROPS */, _hoisted_13)
                    }), 64 /* STABLE_FRAGMENT */))
                  ], 8 /* PROPS */, _hoisted_12),
                  _createElementVNode("div", _hoisted_14, [
                    _createCommentVNode(" <button type=\"button\" class=\"text-xl py-1 px-2 hover:bg-gray-300\" @click=\"decrementQty(item)\">-</button> "),
                    _withDirectives(_createElementVNode("input", {
                      type: "number",
                      class: "p-1 px-2 font-mono w-16",
                      "onUpdate:modelValue": $event => ((item.qty) = $event)
                    }, null, 8 /* PROPS */, _hoisted_15), [
                      [_vModelText, item.qty]
                    ]),
                    _createCommentVNode(" <button type=\"button\" class=\"text-xl py-1 px-2 hover:bg-gray-300\" @click=\"item.qty++\">+</button> ")
                  ])
                ])
              ]))
            }), 256 /* UNKEYED_FRAGMENT */)),
            _createElementVNode("button", {
              type: "button",
              disabled: _ctx.cart.items.length == 0,
              class: _normalizeClass(["btn w-full mt-4", _ctx.cart.items.length ? 'btn-primary' : 'bg-gray-100' ]),
              onClick: _cache[2] || (_cache[2] = $event => (_ctx.step++))
            }, "Request a Quote", 10 /* CLASS, PROPS */, _hoisted_16)
          ], 512 /* NEED_PATCH */), [
            [_vShow, _ctx.step==0]
          ]),
          _withDirectives(_createElementVNode("button", {
            class: "flex gap-2 cursor-pointer font-light",
            onClick: _cache[3] || (_cache[3] = $event => (_ctx.step = 0))
          }, [
            _createCommentVNode(" back icon "),
            _cache[8] || (_cache[8] = _createElementVNode("svg", {
              xmlns: "http://www.w3.org/2000/svg",
              fill: "none",
              viewBox: "0 0 24 24",
              "stroke-width": "1.5",
              stroke: "currentColor",
              class: "size-4"
            }, [
              _createElementVNode("path", {
                "stroke-linecap": "round",
                "stroke-linejoin": "round",
                d: "M9 15 3 9m0 0 6-6M3 9h12a6 6 0 0 1 0 12h-3"
              })
            ], -1 /* CACHED */)),
            _cache[9] || (_cache[9] = _createElementVNode("p", { class: "text-sm" }, "Back", -1 /* CACHED */))
          ], 512 /* NEED_PATCH */), [
            [_vShow, _ctx.step == 1]
          ]),
          _withDirectives(_createElementVNode("div", _hoisted_17, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.cart.items, (item) => {
              return (_openBlock(), _createElementBlock("div", _hoisted_18, [
                _createElementVNode("img", {
                  src: _ctx.productImage(item),
                  class: "size-14"
                }, null, 8 /* PROPS */, _hoisted_19),
                _createElementVNode("div", _hoisted_20, _toDisplayString(item.qty), 1 /* TEXT */)
              ]))
            }), 256 /* UNKEYED_FRAGMENT */))
          ], 512 /* NEED_PATCH */), [
            [_vShow, _ctx.step == 1]
          ]),
          _createCommentVNode(" Quote "),
          _withDirectives(_createVNode(_component_checkout_form, {
            id: "form",
            class: "",
            categories: _ctx.categories
          }, null, 8 /* PROPS */, ["categories"]), [
            [_vShow, _ctx.step == 1]
          ])
        ]))
      : _createCommentVNode("v-if", true)
  ]))
}